/** Triggers a browser download for an in-memory blob (see CustomerAuth.tsx's downloadCredentials
 * for the original inline version of this same createObjectURL + <a> + revokeObjectURL sequence). */
export function triggerBlobDownload(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  link.click()
  URL.revokeObjectURL(url)
}
